import { FormatHelpers } from "../../helpers/format-helpers";
import { StringHelpers } from "../../helpers/string-helpers";
import { TradeOrderMessageHelpers } from "../../helpers/trade-order-message-helpers";
import { IChartContainer } from "../../models/base/chart-container.interface";
import { ChartSettingsPopupModel } from "../../models/chart-style/chart-settings-popup.model";
import { QuoteType } from "../../models/trade/trade.model";
import { IComponent } from "../component.interface";
import { InformationPopupComponent, InformationPopupType } from "../information-popup.component";
import { TradeComponent } from "../trade.component";
import { TradeOrderTypeComponent } from "./trade-order-type.component";

export class BuyButtonWithCurrentPriceMenuComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;
    private tradeComponent: TradeComponent;
    private tradeOrderTypeComponent: TradeOrderTypeComponent;
    private subscribedToTradeComponent = false;
    private yValue = 0;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.id = StringHelpers.newGuid();
        this.element = el;
        this.base = base;
        this.getTradeComponents();
        this.onClick();
        this.subscribeChartRequirmentData();
    }

    public updateValue(yValue: number) {
        this.yValue = yValue;
        this.setLabel();
    }

    private setLabel() {
        this.getTradeComponents();
        if (this.tradeComponent && this.tradeOrderTypeComponent) {
            const priceString = `$${FormatHelpers.numberToStringThousandSeparators(this.yValue, true)}`;
            this.element.findFirst('.val')?.setInnerHtml(`at ${priceString}`);
        }
    }

    private requestBuy() {
        if (!this.yValue) return;

        this.getTradeComponents();

        const tradeModel = this.tradeComponent.getTradeModel();
        if (tradeModel && this.tradeOrderTypeComponent.value && this.tradeOrderTypeComponent && !isNaN(tradeModel.quoteQuantity)) {
            const popup = this.base.getComponentsByType(InformationPopupComponent)[0] as InformationPopupComponent;
            
            let chartSettingsPopupModel = this.base.tiChartSeries?.chartStyleSettings?.chartSettingsPopupModel;
            if (!chartSettingsPopupModel) {
                chartSettingsPopupModel = new ChartSettingsPopupModel();
            }

            if (popup && chartSettingsPopupModel.displayOrderConfirmationPopup) {
                const message = TradeOrderMessageHelpers.getMessage(
                    true,
                    this.tradeOrderTypeComponent.value as QuoteType,
                    tradeModel.orderType,
                    tradeModel.quoteQuantity,
                    tradeModel.tif,
                    this.base.tiChartSeries.symbol,
                    tradeModel.price,
                    tradeModel.account);

                popup.show(message.title, message.message, (dontShowMessage: boolean) => {
                    chartSettingsPopupModel.displayOrderConfirmationPopup = !dontShowMessage;
                    this.base.chartService.requestSaveChartSettingsPopupModel(chartSettingsPopupModel);

                    this.base.chartService.requestInitiateChartTrade(this.yValue, true, this.tradeOrderTypeComponent.value, this.tradeComponent.getAccountName(), this.tradeComponent.getQuoteQuantity());
                }, InformationPopupType.TradeConfirmation);
            } else {
                this.base.chartService.requestInitiateChartTrade(this.yValue, true, this.tradeOrderTypeComponent.value, this.tradeComponent.getAccountName(), this.tradeComponent.getQuoteQuantity());
            }
        }
    }

    private getTradeComponents() {
        if (!this.tradeComponent) {
            this.tradeComponent = this.base.getComponentsByType(TradeComponent)[0] as TradeComponent;
            this.tradeComponent?.onChange(() => {
                this.setLabel();
            });
        }

        if (!this.tradeOrderTypeComponent) {
            this.tradeOrderTypeComponent = new TradeOrderTypeComponent(this.element.findFirst('.trade-order-type'), this.base, this.base.tiChartMenu);
            this.tradeOrderTypeComponent.onChange(() => {
                this.setLabel();
            });

            this.base.components.push(this.tradeOrderTypeComponent);
        }
    }

    private onClick() {
        this.element.findFirst('.button')?.addEventListener('click', () => {
            if (this.element.containClass('disabled')) {
                return;
            }

            this.requestBuy();
        });
        this.element.findFirst('.val')?.addEventListener('click', () => {
            if (this.element.containClass('disabled')) {
                return;
            }

            this.requestBuy();
        });
    }

    private subscribeChartRequirmentData() {
        this.base.chartService.subscribeChartStyleData(() => {
            if (!this.subscribedToTradeComponent) {
                const tradeComponent = this.base.getComponentsByType(TradeComponent)[0] as TradeComponent;
                if (tradeComponent) {
                    this.subscribedToTradeComponent = true;
                    tradeComponent.onChange(() => {
                        this.toggleButton(tradeComponent.getAccountName());
                    });
                    this.toggleButton(tradeComponent.getAccountName());
                }
            }
        });
    }

    private toggleButton(accountName: string) {
        if (!accountName) return;
        this.element.removeClass('disabled');
        this.element.setAttribute('title', 'Buy with ' + accountName);
    }
}